/**
 *
 * @param {*} categoryId
 * @returns category
 */
export const getCategoryById = function (categoryId) {
  switch (Number(categoryId)) {
    case 1:
      return {
        id: 1,
        phobia: "Cynophobia",
        title: "Fear of Dogs",
        image: "programs/cynophobia-soft",
        tagline: "Reclaim your walks",
        statement: {
          title:
            "Dogs are so commonplace yet unpredictable that even mild cynophobia can quickly become unmanageable.",
          description:
            "If this is affecting your quality of life then it's time to get your fear back on its leash",
        },
      };
    case 2:
      return {
        id: 2,
        phobia: "Arachnophobia",
        title: "Fear of Spiders",
        image: "programs/arachnophobia-soft",
        tagline: "Time to unravel the web of your fears.",
        statement: {
          title: "Fear of spiders is incredibly common.",
          description:
            "Many people have it to a lesser or greater degree. It's only when it's interfering with your ability to go places and do the things you want or need to do, that it becomes a real problem. So, let's sweep away the cobwebs and get rid of your arachnophobia",
        },
      };
    case 3:
      return {
        id: 3,
        phobia: "Trypanophobia",
        title: "Fear of needles",
        image: "programs/trypanophobia-soft",
        tagline: "Time to get to the point ",
        statement: {
          title:
            "The need for needles and injections seems everwhere in the world today.",
          description:
            "If your fear of needles is getting in the way of you protecting yourself or offering life saving assistance to your loved ones it's time to make a change. ",
        },
      };
    case 4:
      return {
        id: 4,
        phobia: "Social Anxiety",
        title: "Social Anxiety",
        image: "programs/social-anxiety-soft",
        tagline: "Be the best you in any situation",
        statement: {
          title: "Social anxiety is on the rise.",
          description:
            "Currently 1 in 10 people are affected. If you're finding yourself in this situation it's time to stop being a statistic and deal to your Social Anxiety once and for all.",
        },
      };
    case 5:
      return {
        id: 5,
        phobia: "Ornithophobia",
        title: "Fear of birds",
        image: "programs/ornithophobia-soft",
        tagline: "Let's get back outside.",
        statement: {
          title:
            "Birds are so commonplace yet unpredictable that even mild ornithophobia can quickly become unmanageable.",
          description:
            "If this is affecting your quality of life then it's time to get your fear back into its birdcage.",
        },
      };
    case 6:
      return {
        id: 6,
        phobia: "Acrophobia",
        title: "Fear of Heights",
        image: "programs/acrophobia-soft",
        tagline: "Let's get you grounded.",
        statement: {
          title: "It's not unusual to have a degree of caution around heights.",
          description:
            "But when it begins to intrude on your everyday life - being in carparking buildings, or in highrise offices - or interfering with activities you want to do with loved ones, it's time to take action and conquor your acrophobia.",
        },
      };
    case 7:
      return {
        id: 7,
        phobia: "Aerophobia",
        title: "Fear of Flying",
        image: "programs/aerophobia-soft",
        tagline: "So you can go anywhere",
        statement: {
          title:
            "Did you know that 1 in 4 people get anxious when they need to fly?",
          description:
            "A little anxiety is fine but when it gets in the way of your holidays, promotions or seeing loved ones - it's time to get rid of your aerophobia for good.",
        },
      };
    case 8:
      return {
        id: 8,
        phobia: "Claustrophobia",
        title: "Fear of Small Spaces",
        image: "programs/claustrophobia-soft",
        tagline: "Rediscover the comfort in closeness",
        statement: {
          title: "Cramped and confined spaces are concerning for many people.",
          description:
            "But when your claustrophobia is getting in the way of your everyday life then it's time to take control back from your fears.",
        },
      };
    case 9:
      return {
        phobia: "Amaxophobia",
        title: "Fear of Driving",
        image: "programs/amaxophobia-soft",
        tagline: "Time to get back in the driver's seat",
        id: categoryId,
        statement: {
          title:
            "It's an everyday activity, yet it's not unusual to feel anxious around driving.",
          description:
            "If you find yourself unable to drive because of overwhelming fear, then it's time to get back in control of the vehicle.",
        },
      };
    case 1043:
      return {
        phobia: "Amaxophobia",
        title: "Fear of Driving",
        image: "programs/amaxophobia-soft",
        tagline: "Time to get back in the driver's seat",
        id: categoryId,
        statement: {
          title:
            "It's an everyday activity, yet it's not unusual to feel anxious around driving.",
          description:
            "If you find yourself unable to drive because of overwhelming fear, then it's time to get back in control of the vehicle.",
        },
      };
    case 10:
      return {
        id: 10,
        phobia: "Entomophobia",
        title: "Fear of Insects",
        image: "programs/entomophobia-soft",
        tagline: "Time to stop worrying about small things",
        statement: {
          title:
            "Because they are everywhere even a mild fear of insects can quickly become unmaneagable.",
          description:
            "If the thought of insects being near you is stopping you doing the things you want to do it's time to take action, and overcome your entomophobia.",
        },
      };
    case 13:
      return {
        id: 13,
        phobia: "Musophobia",
        title: "Fear of mice & rats",
        image: "programs/musophobia-soft",
        tagline: "Escape the trap of your fears",
        statement: {
          title:
            "Mice and rats are so commonplace yet unpredictable that even mild musophobia can quickly become unmanageable.",
          description:
            "If your phobia is affecting your quality of life then it's time to reclaim the small spaces of your house from your fears.",
        },
      };
    case 14:
      return {
        id: 14,
        phobia: "Agoraphobia",
        title: "Panic Disorder",
        image: "programs/panic-disorder-soft",
        tagline: "Escape the fear for good",
        statement: {
          title:
            "Living life fearing upcoming panic attacks is the reality for nearly 12 million American adults.",
          description:
            "If you avoid doing things or going places because you're scared of being embarrassed or not being able to escape - help is on the way.",
        },
      };
    case 15:
      return {
        id: 15,
        phobia: "Emetephobia",
        title: "Fear of Vomit",
        image: "programs/vomiting-soft",
        tagline: "Rewrite your 'gut' instinct",
        statement: {
          title: "Fear of vomit can turn your life upside-down.",
          description:
            "But it is highly treatable! It's time to say goodbye to stomach-churning anxiety and rediscover your appetite for life.",
        },
      };
    case 16:
      return {
        id: 16,
        phobia: "Glossophobia",
        title: "Fear of public speaking",
        image: "programs/public-speaking-soft",
        tagline: "Learn to love the spotlight",
        statement: {
          title: "75% of people say public speaking is their #1 fear.",
          description:
            "But it's also a hugely valuable skill that helps get ahead in your professional and personal life. Let's get your fear off the stage and get you in its place.",
        },
      };
    case 21:
      return {
        id: categoryId,
        phobia: "Children's Program",
        title: "5 - 1043 years",
        tagline: "Designed for Children & Adolescent",
        image: "programs/other-soft",
        statement: {
          title: "",
          description: "",
        },
      };
    case 22:
      return {
        id: categoryId,
        phobia: "Children's Program",
        title: "10 - 13 years",
        tagline: "Designed for Children & Adolescent",
        image: "programs/other-soft",
        statement: {
          title: "",
          description: "",
        },
      };
    case 24:
      return {
        id: categoryId,
        phobia: "Children's Program",
        title: "14 - 17 years",
        tagline: "Designed for Children & Adolescent",
        image: "programs/other-soft",
        statement: {
          title: "",
          description: "",
        },
      };
    case 1001:
      return {
        id: categoryId,
        phobia: "Mild Depression",
        title: "Mild Depression",
        tagline: "Let's work our way up",
        image: "programs/mild-depression-soft",
        statement: {
          title: "Depression isn't just low mood, it's a disease",
          description:
            "Like most diseases there are effective treatments available. So, if you've gone past low mood into mild depression, let's work together to make things better.",
        },
      };
    case 1010:
      return {
        id: 1010,
        phobia: "Thalassophobia",
        title: "Fear of deep water",
        image: "programs/deep-water-soft",
        tagline: "Time to take the plunge",
        statement: {
          title:
            "If the thought of venturing into deep water sends waves of panic through your body, you're not alone.",
          description:
            "But you do not have to stay anchored to the fear. Discover how our thalassophobia program can help you set sail and navigate towards a new horizon.",
        },
      };
    case 1012:
      return {
        id: 1012,
        phobia: "Vaping",
        title: "Vaping Addiction",
        image: "vaping-addiction",
        tagline: "Break from the addiction",
        statement: {
          title: "",
          description: "",
        },
      };
    case 1013:
      return {
        id: 1013,
        phobia: "Driving",
        title: "Allianz Driving",
        image: "programs/amaxophobia-soft",
        tagline: "Time to get back in the driver's seat",
        statement: {
          title:
            "It's an everyday activity, yet it's not unusual to feel anxious around driving.",
          description:
            "If you find yourself unable to drive because of overwhelming fear, then it's time to get back in control of the vehicle.",
        },
      };
    case 1031:
      return {
        id: 1031,
        phobia: "Trypophobia",
        title: "Fear of holes or patterns",
        image: "programs/trypophobia-soft",
        tagline: "Break free from tiny holes.",
        statement: {
          title: "Tiny holes don't have to control your life.",
          description:
            "Break free from the urge to look away and discover a calmer, more comfortable way to experience the world.",
        },
      };
    default:
      return {
        id: categoryId,
        phobia: "Unknown",
        title: "Phobia could not be found",
        image: "programs/other-soft",
        description: "",
        tagline: "",
        statement: {
          title: "Did you know that 9.1% of people suffer from phobias?",
          description:
            "Everybody is scared of something. But when that fear starts to get in the way of your daily life - it's time to get rid of your phobia for good!",
        },
      };
  }
};
